// The roof remediation process InRange proposed to Amazon (Noaa's email to David, Oct 2026),
// shown wherever the page marks the roof step's process as not agreed (RoofProcess.tsx).
import type { Owner } from "./pathSteps";

export interface RoofProcessStep {
  n: number;
  owner: Owner;
  title: string;
  line: string;
  /** Happens only if the pre-construction test fails. */
  ifFails?: true;
}

export const ROOF_PROCESS: RoofProcessStep[] = [
  {
    n: 1,
    owner: "amazon",
    title: "Roof condition report",
    line: "Amazon provides a roof condition report for each building. Amazon validates whether report adheres to watertight test per EUSDR.",
  },
  {
    n: 2,
    owner: "inrange",
    title: "PV readiness visual report",
    line: "Our installers check the installation area for PV-relevant issues only.",
  },
  {
    n: 3,
    owner: "amazon",
    title: "Remediation scope",
    line: "Amazon's report and our visual report together set the scope. Works should prepare roof for passing watertight test.",
  },
  {
    n: 4,
    owner: "amazon",
    title: "Remediation",
    line: "Amazon completes the works through the RME approval route before construction starts.",
  },
  {
    n: 5,
    owner: "inrange",
    title: "Pre-construction watertight test",
    line: "We test the roof per the EUSDR, pending disambiguation of requirements.",
  },
  {
    n: 6,
    owner: "amazon",
    title: "If the test fails",
    line: "Further remediation before installation can go ahead.",
    ifFails: true,
  },
  {
    n: 7,
    owner: "inrange",
    title: "Post-installation watertight test",
    line: "We test again after installation to confirm we met every requirement.",
  },
];
